/* ==========================================================================
   Nooroots | Formula Comparison
   DATA LOADING, SHOPIFY VERSION

   Loads the packed data file (ashlion-formula-comparison-data-pack.js),
   unscrambles it and rebuilds the dataset the engine expects.
   Same interface as the local loader: load(url) never rejects and resolves to
     { ok: true, dataset } or { ok: false, code: 'DATASET_UNAVAILABLE' | 'SCHEMA_INVALID' }
   ========================================================================== */
(function (root) {
  'use strict';

  var DEFAULT_URL = 'ashlion-formula-comparison-data-pack.js';
  var cache = {};

  function deepFreeze(o) {
    if (o && typeof o === 'object' && !Object.isFrozen(o)) {
      Object.freeze(o);
      Object.keys(o).forEach(function (k) { deepFreeze(o[k]); });
    }
    return o;
  }

  function rot47(s) {
    var out = [];
    for (var i = 0; i < s.length; i++) {
      var c = s.charCodeAt(i);
      out.push(c >= 33 && c <= 126 ? String.fromCharCode(33 + ((c - 33 + 47) % 94)) : s.charAt(i));
    }
    return out.join('');
  }

  function expand(node, names) {
    if (Array.isArray(node)) return node.map(function (x) { return expand(x, names); });
    if (!node || typeof node !== 'object') return node;
    var o = {};
    Object.keys(node).forEach(function (k) { o[names[parseInt(k, 36)]] = expand(node[k], names); });
    return o;
  }

  function unpack(text) {
    var p = JSON.parse(rot47(text));
    return expand(p.d, p.k);
  }

  function takePack() {
    var text = root.AshlionComparisonPack;
    try { delete root.AshlionComparisonPack; } catch (e) { root.AshlionComparisonPack = undefined; }
    return text;
  }

  function finish(text) {
    if (typeof text !== 'string') return { ok: false, code: 'DATASET_UNAVAILABLE' };
    var data;
    try { data = unpack(text); } catch (e) { return { ok: false, code: 'SCHEMA_INVALID' }; }
    var engine = root.AshlionComparisonEngine;
    var check = engine ? engine.checkSchema(data) : { ok: false, code: 'SCHEMA_INVALID' };
    return check.ok ? { ok: true, dataset: deepFreeze(data) } : { ok: false, code: check.code };
  }

  function load(url) {
    url = url || DEFAULT_URL;
    if (cache[url]) return cache[url];
    cache[url] = new Promise(function (resolve) {
      if (typeof root.AshlionComparisonPack === 'string') { resolve(finish(takePack())); return; }
      var s = root.document.createElement('script');
      s.src = url;
      s.async = true;
      s.onload = function () {
        var res = finish(takePack());
        if (!res.ok) delete cache[url];
        resolve(res);
      };
      s.onerror = function () {
        delete cache[url]; // allow "Try again"
        if (s.parentNode) s.parentNode.removeChild(s);
        resolve({ ok: false, code: 'DATASET_UNAVAILABLE' });
      };
      root.document.head.appendChild(s);
    });
    return cache[url];
  }

  root.AshlionComparisonData = { load: load, unpack: unpack, DEFAULT_URL: DEFAULT_URL };
})(typeof self !== 'undefined' ? self : this);
